import Vue from 'vue'
import Router, {RawLocation, RouteConfig} from 'vue-router'
import Layout from '@/layout/index.vue'
import resourceRouter from './modules/resource'
import equiptypeManage from './modules/equiptypeManage'
import equipManage from './modules/equipManage'
import trainplanManage from './modules/trainplanManage'
import equipAnalyseManage from './modules/equipAnalyseManage'
import resultsAnalyse from './modules/resultsAnalyse'
import autolearnCount from './modules/autolearnCount'
import ratsheetManage from './modules/ratsheetManage'
import adminManage from './modules/adminManage'
import adminExpert from './modules/adminExpert'
import injuruManage from './modules/injuruManage'
import userinfo from './modules/userinfo'
import examineeManage from './modules/examineeManage'
import tissuemanage from './modules/tissuemanage'
import register from './modules/register'
import declare from './modules/declare'

import ladder from './modules/ladder'
import conclusion from './modules/conclusion'

Vue.use(Router)

/*
name: 'router-name'             使用<keep-alive>时需要name字段，它还应该与组件的name属性匹配
redirect:                       如果设置为“noredirect”，则单击面包屑时不会触发重定向操作
meta: {
  role: '1'                    控制页的对应数字（允许设置一个）
  title: 'title'               子菜单和面包屑中显示的名称
  icon: 'svg-name'             侧边栏中显示的图标
  hidden: true                 如果为true，则此路由不会显示在侧栏中（默认为false）
  alwaysShow: true             如果为true，将始终显示根菜单(默认为 false)，如果为false，则在具有小于或等于一个子路由时隐藏根菜单
  breadcrumb: false            如果为false，则该项将在面包屑中隐藏（默认为true）
  noCache: true                如果为true，则不会缓存该页（默认为false）
  affix: true                  如果为true，标签将粘贴在标签视图中
  activeMenu: '/example/list'  如果设置路径，侧边栏将突出显示您设置的路径
*/


// 没权限的基本路由
export const constantRoutes: RouteConfig[] = [

  {
    path: '/redirect',
    component: Layout,
    meta: {hidden: true},
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import(/* webpackChunkName: "redirect" */ '@/views/redirect/index.vue')
      }
    ]
  },
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
    meta: {hidden: true, title: "课题申报管理系统"}
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
    meta: {hidden: true}
  },
  {
    path: '/',
    component: Layout,
    // redirect: '/tissuemanage/tissuemanage',
    redirect: '',
    // children: [
    //   {
    //     path: '/tissuemanage/tissuemanage',
    //     component: () => import(/* webpackChunkName: "dashboard" */ '@/views/tissuemanage/index.vue'),
    //     meta: {
    //       title: "课题申报",
    //       icon: 'resource',
    //     }
    //   }
    // ]
  },

  equipAnalyseManage,
  resultsAnalyse,
  autolearnCount,
  adminManage,
  adminExpert,
  ratsheetManage,
  injuruManage,
  equiptypeManage,
  equipManage,
  trainplanManage,
  resourceRouter,
  userinfo,
  examineeManage,
  tissuemanage,
  declare,
  register,

  ladder,
  conclusion,
]
// 有权限的动态路由
export const asyncRoutes: RouteConfig[] = [
  {
    path: '/example',
    component: Layout,
    redirect: '/example/tree',
    meta: {
      title: 'Example',
      icon: 'example',
      role: '1'
    },
    children: [
      {
        path: 'tree',
        name: 'Tree',
        component: () => import(/* webpackChunkName: "tree" */ '@/views/tree/index.vue'),
        meta: {
          title: 'Tree',
          icon: 'tree',
          role: '11'
        }
      },
      {
        path: 'table',
        name: 'Table',
        component: () => import(/* webpackChunkName: "table" */ '@/views/table/index.vue'),
        meta: {
          title: 'Table',
          icon: 'table',
          role: '12'
        }
      }
    ]
  },
  {
    path: '/form',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'Form',
        component: () => import(/* webpackChunkName: "form" */ '@/views/form/index.vue'),
        meta: {
          title: 'Form',
          icon: 'form',
          role: '2'
        }
      }
    ]
  },
  {
    path: '/nested',
    component: Layout,
    redirect: '/nested/menu1',
    meta: {
      title: 'Nested',
      icon: 'nested',
      role: '3'
    },
    children: [
      {
        path: 'menu1',
        component: () => import(/* webpackChunkName: "menu1" */ '@/views/nested/menu1/index.vue'),
        redirect: '/nested/menu1/menu1-1',
        meta: {
          title: 'Menu1',
          role: '31'
        },
        children: [
          {
            path: 'menu1-1',
            component: () => import(/* webpackChunkName: "menu1-1" */ '@/views/nested/menu1/menu1-1/index.vue'),
            meta: {
              title: 'Menu1-1',
              role: '311'
            }
          },
          {
            path: 'menu1-2',
            component: () => import(/* webpackChunkName: "menu1-2" */ '@/views/nested/menu1/menu1-2/index.vue'),
            redirect: '/nested/menu1/menu1-2/menu1-2-1',
            meta: {
              title: 'Menu1-2',
              role: '312'
            },
            children: [
              {
                path: 'menu1-2-1',
                component: () => import(/* webpackChunkName: "menu1-2-1" */ '@/views/nested/menu1/menu1-2/menu1-2-1/index.vue'),
                meta: {
                  title: 'Menu1-2-1',
                  role: '3121'
                }
              },
              {
                path: 'menu1-2-2',
                component: () => import(/* webpackChunkName: "menu1-2-2" */ '@/views/nested/menu1/menu1-2/menu1-2-2/index.vue'),
                meta: {
                  title: 'Menu1-2-2',
                  role: '3122'
                }
              }
            ]
          },
          {
            path: 'menu1-3',
            component: () => import(/* webpackChunkName: "menu1-3" */ '@/views/nested/menu1/menu1-3/index.vue'),
            meta: {
              title: 'Menu1-3',
              role: '313'
            }
          }
        ]
      },
      {
        path: 'menu2',
        component: () => import(/* webpackChunkName: "menu2" */ '@/views/nested/menu2/index.vue'),
        meta: {
          title: 'Menu2',
          role: '32'
        }
      }
    ]
  },
  {
    path: 'external-link',
    component: Layout,
    meta: {
      role: '5'
    },
    children: [
      {
        path: 'https://www.baidu.com/',
        meta: {
          title: 'External Link',
          icon: 'link',
          role: '51'
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    meta: {hidden: true}
  }
]
const createRouter = () => new Router({
  // mode: 'history',  // Disabled due to Github Pages doesn't support this, enable this if you need.
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  },
  base: process.env.BASE_URL,
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter();
  (router as any).matcher = (newRouter as any).matcher // reset router
}

router.onError((error) => {
  console.log('error', error)
});
export default router
